import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
require("../node_modules/semantic-ui-css/semantic.css");
var VueTruncate = require('vue-truncate-filter');
Vue.use(VueTruncate);
import VueTheMask from 'vue-the-mask'
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCR0zZ8O-NXQr9BvODkoeByPVnX3441mRI',
    libraries: 'places'
  }
})
const $ = require('jquery')
window.$ = $
window.jQuery = $
require('jquery-confirm')
require('semantic-ui-css/semantic')
require('@fortawesome/fontawesome-free/js/all')
Vue.use(VueTheMask);
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")
